import { render } from "./PaymentMethodsDialog.vue?vue&type=template&id=7f80c4a6"
import script from "./PaymentMethodsDialog.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__